import { useEffect, useMemo, useState } from 'react';
import { validate as uuidValidate } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Logo from '../../../images/header-image.png';
import { EventsState } from '../../../store/types';
import { Channel } from '../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import classNames from 'classnames';
import AdminNav from './admin-nav';
import EventNav from './event-nav';
import { ProfileDetails } from '../../general-ui//profile-details/profile-details';
import NavigationDropdown from '../../general-ui/dropdown/navigation-dropdown';
import { setAdminChannel } from "../../../store/actions/authentication";
import IssueCollector from '../../issue-collector/issue-collector';

interface Avatar {
	channel: Channel;
}

export function ChannelAvatar({ channel }: Avatar): JSX.Element {
	return useMemo(() => {
		if (channel.colors.primary && channel.logos.white) {
			return (
				<div
					className="channel-avatar"
					style={{
						backgroundColor: channel.colors.primary
							? `${channel.colors.primary}`
							: '#333333',
					}}
				>
					<img
						src={channel.logos.white}
						alt={channel.name}
					/>
				</div>
			);
		} else {
			return (
				<div
					className="channel-avatar"
					style={{ backgroundColor: '#fff' }}
				>
					{channel.logos.color ? (
						<img
							src={channel.logos.color}
							alt={channel.name}
						/>
					) : (
						<h5>{channel.name[0]}</h5>
					)}

				</div>
			);
		}
	}, [channel]);
}

export default function Header(): JSX.Element {
	const {
		AuthReducer: { channels, token, user },
	} = useSelector((state: EventsState) => state);

	const dispatch = useDispatch();
	const location = useLocation();
	const history = useHistory();
	// const { pathname } = location;
	const [profileDetailsOpen, setProfileDetailsOpen] = useState(false);

	const [, base, content, action, eventUUID] = useMemo(
		() => location.pathname.split('/'),
		[location]
	);

	useEffect(() => {
		//needed for the events (and currentEvent) to load upon refreshing
		// if (!events.length && content === 'events') { dispatch(getEvents(user!.active_channel, token!)); }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token, user]);

	const currentChannel = useMemo(
		() =>
			channels.find(
				({ channel }) => channel === (user!.active_channel)
			),
		[channels, user]
	);

	// const currentEvent = useMemo(
	// 	() => events.find(({ uuid }) => uuid === eventUUID),
	// 	[eventUUID, events]
	// );

	// const hasChannels = channels.length > 1;

	function selectChannel(channel: Channel) {
		return async () => {
			if (token) {
				// Await so redirect of /admin works properly
				await dispatch(setAdminChannel(token, channel.channel));
				history.push('/admin');
			}
		};
	}

	if (base === 'admin') {
		if (action !== 'create') {
			return (
				<header className="admin-header">
					<div className="left">
						{currentChannel ? (
							<AdminNav currentChannel={currentChannel} />
						) : (
							<></>
						)}
					</div>
					<div className="right">
						{/* FUTURE DEV - button is not being implemented for MVP but will be used in the future */}
						{/* <button className="no-style notifications-button">
							<div className="notifications">
								<Icon name={ICONS.BELL} size={16} color={COLORS.DEFAULT_GRAY} />
							</div>
						</button> */}
						<IssueCollector />

						<button className="no-style profile-button" onClick={() => setProfileDetailsOpen(!profileDetailsOpen)}>
							<div className="profile-pic">
								{user?.profile?.picture ? (
									<img
										src={user!.profile.picture}
										alt={
											user!.profile.first_name + ' ' + user!.profile.last_name
										}
									/>
								) : (
									<Icon
										name={ICONS.SETTINGS_TRANSPARENT}
										color={COLORS.BLACK}
										size={40}
									/>
								)}
							</div>
							<div className="profile-pic-arrow">
								<Icon
									name={ICONS.KEYBOARD_ARROW_RIGHT}
									size={12}
									color={profileDetailsOpen ? COLORS.WHITE : COLORS.GRAY}
								/>
							</div>
						</button>
						<ProfileDetails
							open={profileDetailsOpen}
							account={user!}
							onClose={() => setProfileDetailsOpen(false)}
						>
						</ProfileDetails>
					</div>
				</header>
			);
		} else {
			if (content === 'events' && action === 'create' && uuidValidate(eventUUID)) {
				return (
					<header className="admin-header in-editor">
						<div className="left">
							<NavigationDropdown
								title={<>
									{currentChannel
										? <ChannelAvatar channel={currentChannel} />
										: <img src={Logo} alt={"Brandlive"} />
									}
								</>}
								isArrow={false}
								className="channels"
							>
								{channels.map((channel: Channel) => (
									<div className={classNames("channel-item", { on: channel.channel === user!.active_channel })} key={channel.channel} onClick={selectChannel(channel)}>
										<ChannelAvatar channel={channel} />
										<label>{channel.name}</label>
									</div>
								))}
							</NavigationDropdown>
							{currentChannel ? (
								<EventNav />
							) : (<></>)}
						</div>
						<div className="right">

						</div>
					</header>
				);
			} else {
				return <></>;
			}
		}
	}
	return (
		<header className="admin-header">
			<img src={Logo} alt={'Brandlive'} />
		</header>
	);
}
